import type { FaireProductEntity } from "../../entity_types/product";

/**
 * The product the Garden & outdoor PDP sells, so it can also appear in the
 * "Top reordered" list it links to. Sourced from Figma (Brand - Product
 * Insights, node 558:22285) rather than the Faire API — imagery lives in
 * `public/images/awe/`.
 */
export const awePlantMister: FaireProductEntity = {
  token: "awe-plant-mister",
  type: "product",
  name: "Plant Mister",
  brandName: "Jungle Club",
  imageUrl: "/images/awe/plant-mister-1.jpg",
  galleryImageUrls: [
    "/images/awe/plant-mister-2.jpg",
    "/images/awe/plant-mister-3.jpg",
    "/images/awe/plant-mister-4.jpg",
  ],
  priceDollars: 16,
  msrpDollars: 32,
  caseSize: 1,
  description: "",
  categoryTokens: ["cat_garden_outdoor"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-09-11T00:00:00Z",
    importedBy: "awe-top-reordered-prototype",
  },
};
